import styled, { css } from "styled-components";
import { deviceQuery, size } from "../../styles/mediaSizes";

import { NavLink } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "../styled/Button/Button";

export const NavDrawerStyled = styled.div`
  transition: all 0.3s linear;
  flex-wrap: nowrap;

  @media only screen and (max-width: ${size.tabletM}) {
    display: none;
  }
`;

export const NavLinkStyled = styled(NavLink)`
  font-size: ${(props) => props.theme.typography.text1};
  color: ${(props) => props.theme.palette.common.text.primary};

  &:hover {
    color: ${(props) => props.theme.palette.common.text.primary};
  }
`;

export const WalletListStyled = styled.ul`
  list-style: none;
  margin-top: 3.2rem;
  margin-bottom: 2.6rem;

  .wallet-list-item {
    display: flex;
    padding: 1.5rem 3.5rem;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: max-content;
    margin: auto;
    transition: background-color 0.3s ease-in-out;
    &:hover {
      background-color: ${(props) =>
    props.theme.palette.card.text.primary + "22"};
    }

    .arrow {
      width: 2rem;
    }
    .wallet-img {
      height: 100%;
      width: auto;
      margin-left: 1.5rem;
    }
  }
`;

export const HeaderStyled = styled.header`
  padding: 10px 30px;
  z-index: 100;
  background: ${(props) => (props.$showDrawer ? "inherit" : "transparent")};
  border-bottom: 1px solid ${(props) => props.theme.palette.common.border.dark};

  display: flex;
  align-items: center;

  @media ${deviceQuery.laptopS} {
    padding: 10px 16px;
  }

  .logoWrap {
    .mobile-logo {
      display: none;
    }
    .logo {
      display: block;
      height: 26px;
      margin-left: 5rem;
    }

    @media ${deviceQuery.mobileL} {
      .mobile-logo {
        display: block;
      }
      .logo {
        display: none;
      }
    }
  }

  .connect-btn-container {
    ${(props) =>
    props.$showDrawer &&
    css`
        display: none !important;
      `}
    @media ${deviceQuery.tabletM} {
      margin-left: auto;
      padding-right: 0;
    }
  }

  .menu-icon {
    cursor: pointer;
  }
  .navbarWrap {
    flex-grow: 1;
    padding: 0;
    @media ${deviceQuery.tabletM} {
      display: none;
    }
    .navbar {
      justify-content: center;
      padding: 0;
    }
  }
  .navbar {
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-grow: 1;
  }
`;

export const DropdownToggleStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #fff;
  transition: all 0.3s linear;
  width: 5rem;
  cursor: pointer;

  &::after {
    content: none;
  }

  .user-profile {
    position: relative;
    margin-left: 10px;
    overflow: visible;
    flex-shrink: 0;

    img {
      border-radius: 50%;
    }

    &::after {
      content: "";
      display: inline-block;
      border-radius: 50%;
      width: 10px;
      height: 10px;
      position: absolute;
      border: 1.2px solid #fff;
      bottom: 0;
      left: 1px;
      background-color: green;
    }
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  .balance {
    // font-size: 14px;
    font-size: 70%;
    // font-size: ${(props) => props.theme.typography.text1};
    font-weight: 600;
    text-overflow: ellipsis;
    max-width: 12rem;
    overflow: hidden;
    color: ${(props) => props.theme.palette.common.text.primary};
    &.error-net {
      font-size: ${(props) => props.theme.typography.subText4};
    }
  }

  .account-number {
    font-size: 70%;
    max-width: 9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props) => props.theme.typography.subText1};
    color: ${(props) => props.theme.palette.common.text.secondary};
  }
`;

export const DropdownMenuStyled = styled(Dropdown.Menu)`
  width: 21.4rem;
  padding: 0;
  border: none;
  border-radius: 5px;
  background-color: ${(props) => props.theme.palette.common.mainBackground};
  box-shadow: 0px 0px 20px
    ${(props) => props.theme.palette.card.boxShadow.primary};
  margin-right: -60px !important;
  margin-top: 6px !important;

  .dropdown-item {
    display: flex;
    align-items: center;
    padding: 1rem 0;
    font-size: 16px;
    width: calc(100% - 4rem);
    margin: 0 2rem;
    height: 5.4rem;
    cursor: pointer;

    &.notification-item {
      display: none;
      @media only screen and (max-width: ${size.tabletM}) {
        display: flex;
      }
    }

    &:first-child {
      padding: 2.4rem 0 0.8rem;
      span {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: capitalize;
        font-weight: 500;
        font-size: ${(props) => props.theme.typography.text2};
        line-height: 2.5rem;
        margin-left: 0;
      }
    }

    .dropdown-item-icon {
      width: 1.8rem;
      height: 1.8rem;
      fill: red;
    }

    span {
      display: inline-block;
      transition: all 0.3s ease-in-out;
      font-size: ${(props) => props.theme.typography.subText4};
      font-weight: 500;
      margin-left: 1rem;
      color: ${(props) => props.theme.palette.card.text.primary};
    }
    &:hover {
      background-color: transparent;
      /* span:not(:first-child) {
        transform: translateX(10px);
      } */
      .arrow-icon {
        transform: rotate(360deg);
        fill: red;
      }
    }

    &:not(:last-child):not(:first-child) {
      border-bottom: 1px solid rgba(157, 157, 157, 0.1);
    }

    .arrow-icon {
      width: 1.7rem;
      height: 1rem;
      margin-left: auto;
    }
  }
`;

export const NotificationPopperWrap = styled.div`
  @media only screen and (max-width: ${size.tabletM}) {
    display: none;
  }
`;

export const ButtonStyled = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:after {
    content: "";
    width: 40%;
    position: absolute;
    top: 0;
    height: 0px;
    background-color: ${(props) => props.theme.palette.card.text.primary};
    left: 10%;
  }
  span {
    white-space: nowrap;
    font-size: 1.4rem;
  }
`;

export const StyledConnectingButton = styled.div`
  ${(props) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${props.theme.typography.subText4};
    pointer-events: none;
    text-transform: uppercase;
    p {
      margin: 0;
    }

    .loader-wrap {
      width: 3.4rem;
      height: 3.4rem;
      margin-left: 1.6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid ${props.theme.palette.card.text.primary};
      border-radius: 50%;
    }
  `}
`;

export const StakingButton = styled.div`
  margin-left: 55%;
  a {
    background-color: ${(props) => props.theme.palette.common.mainBackground};
    color: ${(props) => props.theme.palette.common.text.primary};
  }
`;

export const StyledTooltip = styled.div`
  font-size: 12px;
`;
